import { useAuth0 } from "@auth0/auth0-react";
import styles from "./addgroup.module.css";
import { Autocomplete, Checkbox, Chip, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useEffect, useState } from "react";
import { createFilterOptions } from '@mui/material/Autocomplete';

const schema = yup.object().shape({
    title: yup.string().required('This field is Required'),
    type: yup.string().required('This field is Required')
});

const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
    ignoreCase: true,
    trim: true
});

const AddGroup = ({ setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, setAllData, editData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [selectContact, setSelectContact] = useState([]);
    const [allProspectList, setAllProspectList] = useState([]);
    const [allTenantList, setAllTenantList] = useState([]);
    const [allContactList, setAllContactList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [selectContactIds, setSelectContactIds] = useState([]);
    const [selectedType, setSelectedType] = useState('');

    const { handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            title: '',
            type: ''
        }
    });

    useEffect(() => {
        const getProspectList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-prospect-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllProspectList(response.data.data);
            }).catch(() => {
            });
        }

        getProspectList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getTenantList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllTenantList(response.data.data);
            }).catch(() => {
            });
        }

        getTenantList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getContactList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-contact-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllContactList(response.data.data);
            }).catch(() => {
            });
        }

        getContactList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        setSelectContact([]);
        setSelectContactIds([]);

        if (selectedType === 'Prospect') {
            setContactList(allProspectList);
        }

        if (selectedType === 'Tenant') {
            setContactList(allTenantList);
        }

        if (selectedType === 'Contact') {
            setContactList(allContactList);
        }

    }, [selectedType, allContactList, allTenantList, allProspectList]);

    useEffect(() => {
        let ids = selectContact.map((i) => {
            return i.id;
        });

        setSelectContactIds(ids);
    }, [selectContact]);

    useEffect(() => {
        if (editData) {
            setValue('type', editData?.type);
            setValue('title', editData?.title);
        }
    }, [editData, setValue]);

    const onSubmit = async (data) => {
        setLoading(true);
        setAddModalOpen(false);

        let contactTemp = [];

        if (data?.type === 'Prospect') {
            contactTemp = selectContactIds?.map(i => {
                return { prospect_id: i };
            });
        }

        if (data?.type === 'Tenant') {
            contactTemp = selectContactIds?.map(i => {
                return { tenant_id: i };
            });
        }

        if (data?.type === 'Contact') {
            contactTemp = selectContactIds?.map(i => {
                return { contact_id: i };
            });
        }

        data = { ...data, contacts: contactTemp }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/campaign/groups', data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg('Group added successfully.');

            setLoading(false);

            setAllData(prev => {
                return [response.data.data].concat(prev);
            });
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        setAddModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_USER_API_URL + 'v1/campaign/groups/' + editData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg('Group updated successfully.');

            setLoading(false);

            setAllData(prev => {
                return prev?.map(item => {
                    if (item.id === editData?.id)
                        return response.data.data;
                    return item;
                })
            });
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<div className={`${styles.AddprospectFirstStepForm}`}>
        <form onSubmit={handleSubmit(editData ? onUpdate : onSubmit)}>
            <div className={`${styles.AddPropertyHalfSecRow}`}>
                <div className={`${styles.HalfSecHalf} FormGroup`}>
                    <Controller
                        name={`title`}
                        control={control}
                        render={(field) => (
                            <TextField
                                onChange={(e) => field.onChange(e)}
                                id="outlined-basic"
                                label="Group Name*"
                                variant="outlined"
                                value={field.value}
                            />
                        )}
                    />
                    {errors.title && (<p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>)}
                </div>
                <div className={`${styles.HalfSecHalf} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Group Type*</InputLabel>
                        <Controller
                            name="type"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Group Type*"
                                    onChange={(e) => {
                                        field.onChange(e);

                                        setSelectedType(e.target.value);
                                    }}
                                    disabled={editData}
                                >
                                    <MenuItem value="Prospect">Prospect</MenuItem>
                                    <MenuItem value="Tenant">Tenant</MenuItem>
                                    <MenuItem value="Contact">Contact</MenuItem>
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.type && (<p className={`${styles.ErrorM}`}>{errors.type.message}</p>)}
                </div>
            </div>
            {!editData && <div className={`${styles.HalfSecFull} FormGroup GroupChip`}>
                <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={contactList}
                    disableCloseOnSelect // Keep dropdown open on selection
                    getOptionLabel={(option) => option.name} // How to get the label for display
                    value={selectContact}
                    filterOptions={filterOptions}
                    onChange={(event, newValue) => {
                        setSelectContact(newValue);
                    }}
                    renderOption={(props, option) => (
                        <MenuItem {...props} disabled={option?.email === ''}>
                            <Checkbox checked={selectContactIds.indexOf(option.id) > -1} />
                            {option.name.trim() !== '' ? option.name : option?.email}
                            {option?.email === '' && <span className={`${styles.NoMailDR}`}>No Email</span>}
                        </MenuItem>
                    )}
                    renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                            <Chip
                                key={index} // Key is important for performance
                                label={option.name.trim() !== '' ? option.name : option?.email}
                                {...getTagProps({ index })} // Spreads necessary props for deletion etc.
                                onDelete={() => {
                                    const newSelection = [...selectContact];
                                    newSelection.splice(index, 1);
                                    setSelectContact(newSelection);
                                }}
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField {...params} label="Contacts" placeholder="Select Contacts" />
                    )}
                />
            </div>}
            <div className={`${styles.ButtonAction}`}>
                <button type="button" onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</button>
                <button type="submit" className="SubmitPopupBU">{editData ? 'Update' : 'Add'}</button>
            </div>
        </form>
    </div>);
}

export default AddGroup;